import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {ReceiptComponent} from './receipt.component';
import {ReceiptDetailComponent} from '../receipt-detail/receipt-detail.component';
import {LoginGuard} from '../login/login.guard';

const routes: Routes = [{
    path: 'receipt',
    component: ReceiptComponent,
    canActivate : [LoginGuard]
  },
  {
    path: 'receipt/new',
    component: ReceiptDetailComponent,
    canActivate: [LoginGuard]
  },
  {
    path: 'receipt/:id',
    component: ReceiptDetailComponent,
    canActivate: [LoginGuard]
  }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReceiptRoutingModule { }



// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/receipt/receipt-routing.module.ts